import {RootState} from "../../types";

export const isFiltersModalOpen = (state: RootState) => state.accounts.filtersModalOpen;